export default "__VITE_ASSET__BbCez$d___"